<template>
  <v-layout column class="pt-6 px-6">
    <v-card
      outlined
      class="pa-0 mb-6 elevation-0 rounded-lg overflow-hidden"
      v-if="globalAlerts.length || facilityAlerts.length"
    >
      <v-expansion-panels
        flat
        data-testid="alert-expansion-panel"
        class="alert-expansion-panel rounded-lg"
        v-model="alertPanel"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-header class="px-6"
            ><h2 class="text-h5">Alerts</h2></v-expansion-panel-header
          >
          <v-expansion-panel-content class="px-0 mx-0">
            <div v-if="globalAlerts.length">
              <v-alert
                v-for="(alert, i) in globalAlerts"
                :key="i"
                dense
                border="left"
                :type="alert.color ? alert.color : 'warning'"
                class="mb-2"
              >
                <span class="font-weight-bold">
                  {{ alert.text }}
                </span>
                <div class="text-caption">
                  Created {{ timeStamp(alert.created_at) }}.
                  <span v-if="alert.created_at !== alert.updated_at">
                    Updated {{ timeStamp(alert.updated_at) }}
                  </span>
                </div>
              </v-alert>
            </div>
            <v-divider
              v-if="globalAlerts.length && facilityAlerts.length"
              class="my-4"
              :color="darkMode ? 'white' : 'black'"
            />
            <div v-if="facilityAlerts.length">
              <v-alert
                v-for="(alert, i) in facilityAlerts"
                :key="i"
                dense
                border="left"
                :type="alert.color ? alert.color : 'warning'"
                class="mb-2"
              >
                <span class="font-weight-bold">
                  {{ alert.text }}
                </span>
                <div class="text-caption">
                  Created {{ timeStamp(alert.created_at) }}.
                  <span v-if="alert.created_at !== alert.updated_at">
                    Updated {{ timeStamp(alert.updated_at) }}
                  </span>
                </div>
              </v-alert>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </v-layout>
</template>

<script>
/* eslint-disable eqeqeq */
import moment from "moment";

export default {
  data() {
    return {
      alertPanel: [0],
      globalAlerts: [],
      alertUpdate: null,
      darkThemeObj: {
        "white--text": true
      }
    };
  },

  methods: {
    timeStamp(date) {
      return moment.utc(date).local().fromNow();
    },

    formatFacility(facility) {
      return facility.length === 1 ? "L00" + facility : "L0" + facility;
    },

    loadAlerts() {
      let oldAlerts = this.globalAlerts;
      this.$store.dispatch("getAllAlerts").then((resp) => {
        if (
          !oldAlerts.length ||
          JSON.stringify(oldAlerts) ==
            JSON.stringify(
              resp.data.alerts.filter((alert) => !alert.facility_id)
            )
        ) {
          // do nothing, no new alerts have been added
        } else {
          this.$store.dispatch(
            "handleAlert",
            "A new global alert was recently added. Please view the alert panel for details."
          );
        }
      });
      this.globalAlerts = this.filterGlobalAlerts;
    }
  },

  computed: {
    facilityAlerts() {
      return this.$store.state.facilities.facilityAlerts;
    },

    filterGlobalAlerts() {
      return this.$store.state.alerts.alerts.filter(
        (global) => !global.facility_id
      );
    },

    darkMode() {
      return !!this.$store.state.application.settings.darkTheme;
    }
  },

  created() {
    this.loadAlerts();
    this.alertUpdate = setInterval(() => {
      this.loadAlerts();
    }, 900000); // check for new alerts every 15 min
  },

  beforeDestroy() {
    clearInterval(this.alertUpdate);
  }
};
</script>

<style scoped>
.v-card__text .layout i {
  color: #ffdf00 !important;
  transform: scale(1.15);
}
</style>
